import React from "react";
import MUISvgIcon from "@material-ui/core/SvgIcon";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";

const SvgIcon = (props: SvgIconProps) => <MUISvgIcon {...props} />;

export { SvgIcon };
